export const errors = {
    generic_axios_error: 'A Network Error Has Occurred. Please try again',
} as const;

export const fetch_timeout_duration = 40000;

export const featureFlags = {
    MAINTENANCE_MODE: 'enable-maintenance',
    POINTS_MODE: 'enable-point-mode',
    LET_THEM_CHOOSE: 'let-them-choose',
    YELP_PIXEL: 'enable-yelp-pixels',
    GCM_VERSION: 'gcm-version',
    KLAVIYO_TRACKING: 'enable-klaviyo-tracking',
    CLEAR_CART_CACHE: 'enable-clear-cart-cache',
    ENABLE_GOOGLE_CAPTCHA: 'enable-google-captcha',
    RESERVATION_MODE: 'enable-reservation',
    ENABLE_SERVICE_PROVIDERS: 'enable-service-providers',
    SEARCH_GOOGLE_SERVICE: 'enable-google-search',
    SEARCH_YELP_SERVICE: 'enable-yelp-search',
    GCM_STORE_CLOSED: 'gcm-store-closed',
    GCM_OPEN_TIME: 'gcm-open-time',
    GCM_CLOSING_TIME: 'gcm-closing-time',
    GCM_DEFAULT_GOOGLE_SEARCH: 'gcm-default-goole-search',
    GCM_DEFAULT_YELP_SEARCH: 'gcm-default-yelp-search',
    VERSION_OF_FEATURE_FLAG_CHANGED: 'version-of-feature-flag-changed',
    VARIABLE_CARD_LOAD: 'variable-card-load',
};
